import Logo from "@/components/Logo";
import DirectAdLink from "@/components/ads/DirectAdLink";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="relative z-10 mt-24 border-t border-[#1a1a1a] bg-[#050505]"
    >
      <div className="mx-auto max-w-7xl px-6 py-12 md:px-12 md:py-16">
        <div className="flex flex-col items-start gap-8 md:flex-row md:items-end md:justify-between">
          <div>
            <Logo size="md" />
          </div>
          <div className="text-xs uppercase tracking-[0.28em] text-[#666666]">
            Design by{" "}
            <a
              data-testid="footer-tyche-link"
              href="https://www.tychelabs.it.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#a3a3a3] underline decoration-[#e60039] underline-offset-4 transition-colors hover:text-[#e60039]"
            >
              Tyche Labs
            </a>
          </div>
        </div>
        <div className="mt-10 flex flex-col gap-3 border-t border-[#1a1a1a] pt-6 text-xs text-[#666666] md:flex-row md:justify-between">
          <span>© {new Date().getFullYear()} XEROTIC. All rights reserved.</span>
          <span className="flex flex-wrap items-center gap-3 uppercase tracking-[0.28em]">
            <DirectAdLink className="hover:text-[#e60039]">Sponsored</DirectAdLink>
            <span aria-hidden>·</span>
            18+ · Adults only
          </span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
